import { Box, Button, Stack, Typography } from "@mui/material";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";

import { BaseModal } from "../Modal/BaseModal";
import LoadingButton from "../Button/LoadingButton";

type ConfirmLogoutModalProps = {
  open: boolean;
  onClose: () => void;
  onLogout: () => void;
  isLogouting: boolean;
};

const ConfirmLogoutModal = ({
  open,
  onClose,
  onLogout,
  isLogouting,
}: ConfirmLogoutModalProps) => {
  return (
    <BaseModal
      open={open}
      onClose={onClose}
      title={
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <WarningAmberIcon color="error" sx={{ fontSize: 28 }} />
          <Typography>{`ログアウト`}</Typography>
        </Box>
      }
      children={
        <>
          <Typography variant="body2" sx={{ whiteSpace: "pre-wrap" }}>
            {`ログアウトします。よろしいですか？`}
          </Typography>
        </>
      }
      actions={
        <Stack direction={"row"} spacing={2}>
          <Button disabled={isLogouting} variant="outlined" onClick={onClose}>
            キャンセル
          </Button>
          <LoadingButton
            isLoading={isLogouting}
            color="error"
            variant="contained"
            onClick={onLogout}
          >
            ログアウト
          </LoadingButton>
        </Stack>
      }
    />
  );
};

export default ConfirmLogoutModal;
